import { ClaimsModel } from '@core/services/auth/models/claims.model';
import { createAction, props } from '@ngrx/store';
import { UserState } from './user.reducers';

export const usersLoad = createAction('[USERS_ACTION] Get Users');
export const usersLoaded = createAction('[USERS_ACTION] Users Loaded', props<UserState>());
export const usersAddRole = createAction('[USERS_ACTION] Users Add Role', props<{ data: { user: string; claim: ClaimsModel } }>());
export const usersRemoveRole = createAction('[USERS_ACTION] Users Remove Role', props<{ data: { user: string; claim: ClaimsModel } }>());
